import React from "react";

export default function Icon() {
  return (
    <svg
      width="103"
      height="54"
      viewBox="0 0 103 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.84277 53V12.1623L1.98371 14.2923L0.294385 5.03772L13.0011 1.21836H20.346V53H9.84277ZM29.312 53V44.4065L44.4425 28.8352C49.8777 23.2531 51.8608 20.462 51.8608 16.7161C51.8608 12.8233 49.2167 10.6199 45.6911 10.6199C42.0921 10.6199 39.5948 12.6764 36.2896 16.7161L29.3854 10.1792C33.8658 4.08288 39.0807 0.851117 46.4991 0.851117C55.974 0.851117 62.6579 6.5067 62.6579 15.8347V15.9816C62.6579 23.1797 59.3526 27.2928 51.7139 34.7112L43.1204 43.4516H62.7313V53H29.312ZM84.9807 53.8814C77.4888 53.8814 71.9802 50.9434 68.0139 46.6834L74.404 39.1916C77.0482 41.9826 80.2065 44.1861 84.7603 44.1861C88.8735 44.1861 91.8849 41.6154 91.8849 37.5022V37.3553C91.8849 32.9484 88.2124 30.3777 81.602 30.3777H78.5171L77.2685 23.6203L88.5797 11.0605H70.7315V1.58561H101.654V10.0323L89.608 22.6655C96.2184 23.9876 102.388 28.1007 102.388 36.9881V37.2084C102.388 47.0506 95.4104 53.8814 84.9807 53.8814Z"
        fill="#CFD4DA"
      />
    </svg>
  );
}
